import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation  } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';

const EBFailed = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const navigate = useNavigate();
  const location = useLocation();
  const handleReattemptPayment = () => {
    navigate("/dashboard");
  };

  return (
    <MainLayout>
      <div className="bg-gray-600 text-center py-8 px-4">
        <h2 className="text-2xl font-semibold mb-4 text-yellow-200">Sorry! Payment Attempt Failed!!!</h2>
        <h2 className="text-xl font-semibold mb-4 text-white">Please Reattempt</h2>
        <div className="bg-gray-800 rounded-lg shadow-md p-6 mx-auto max-w-lg">
          <button
            onClick={handleReattemptPayment}
            className="w-full bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded"
          >
            Back to Dashboard 
          </button>
        </div>
      </div>
    </MainLayout>
  );
};

export default EBFailed;
